import SEOHead from '@/components/feature/SEOHead';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import BusinessAreas from './components/BusinessAreas';
import Partners from './components/Partners';
import Contact from './components/Contact';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Fixcope',
    alternateName: '픽스코프',
    url: siteUrl,
    logo: `${siteUrl}/logo.png`,
    description: '픽스코프는 기술력과 글로벌 네트워크를 바탕으로 머신비전, 초소형 산업용카메라, 국산 의료장비 글로벌 공급, 기업 해외진출 컨설팅을 제공하는 글로벌 솔루션 파트너입니다.',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'KR',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+82-2-2264-2563',
      contactType: 'customer service',
      email: 'info@fixcope.com',
      availableLanguage: ['Korean', 'English'],
    },
    sameAs: [],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Fixcope',
    url: siteUrl,
    inLanguage: 'ko-KR',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteUrl}/?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
];

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="픽스코프(Fixcope) | 글로벌 솔루션 파트너 - 머신비전·의료장비·해외진출"
        description="픽스코프는 기술과 신뢰로 연결하는 글로벌 솔루션 파트너입니다. 머신비전, 초소형 산업용카메라 개발, 국산 의료장비 글로벌 공급, 기업 해외진출 컨설팅을 제공합니다."
        keywords="픽스코프, Fixcope, 글로벌 솔루션, 머신비전, 산업용카메라, 의료장비, 해외진출 컨설팅, 기술 솔루션"
        canonical="/"
        ogTitle="픽스코프(Fixcope) | 글로벌 솔루션 파트너"
        ogDescription="기술과 신뢰로 연결하는 글로벌 솔루션 파트너 픽스코프. 머신비전·의료장비·해외진출 컨설팅 전문."
        lang="ko"
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <Hero />
      <About />
      <BusinessAreas />
      <Partners />
      <Contact />
      <Footer />
    </div>
  );
}
